import { render, staticRenderFns } from "./DataMigracaoField.vue?vue&type=template&id=1d67e16e&scoped=true&"
import script from "./DataMigracaoField.vue?vue&type=script&lang=js&"
export * from "./DataMigracaoField.vue?vue&type=script&lang=js&"
import style0 from "./DataMigracaoField.vue?vue&type=style&index=0&id=1d67e16e&lang=scss&scoped=true&"
import style1 from "./DataMigracaoField.vue?vue&type=style&index=1&id=1d67e16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67e16e",
  null
  
)

export default component.exports